// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 964) return "static/chunks/964-408f128bab710250.js";
	if (chunkId === 756) return "static/chunks/756-cf31b9ba3b9e8eb0.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"47":"fe33484960db8323","131":"65323ae7f4d33bd6","287":"0718b480e5d0e95f","631":"5600baf69d458f23","706":"ab1d909b6854d75b"}[chunkId] + ".js";
};